import React from 'react';

import { useUpdatedRef } from './useUpdatedRef';

/** Merge multiple react refs into a single react object ref */
export const useMergedRefObject = <E>(...refs: Array<React.MutableRefObject<E> | ((item: E) => void)>) => {
    const refsRef = useUpdatedRef(refs);
    const [ref] = React.useState((): React.RefObject<E> => {
        let localItem: E | null = null;
        return {
            get current() {
                return localItem as E;
            },
            set current(item: E) {
                localItem = item;
                if (!refsRef.current) {
                    return;
                }
                for (const ref of refsRef.current) {
                    if (typeof ref === 'function') {
                        ref(item);
                    } else {
                        ref.current = item;
                    }
                }
            },
        };
    });
    return ref;
};
